var _a, _b;
export var PRODUCT_LINES = {
    HONDA: 'honda',
    ACURA: 'acura',
    PE: 'pe',
    MC: 'mc',
    ENGINE: 'engine',
    MARINE: 'marine',
    PSP: 'psp',
    HC: 'hc',
    HF: 'hf',
};
export var CONFIG_ELEMENT_IDS = (_a = {},
    _a[PRODUCT_LINES.HONDA] = '#honda-config-app',
    _a[PRODUCT_LINES.ACURA] = '#acura-config',
    _a[PRODUCT_LINES.PE] = '#pe-config',
    _a[PRODUCT_LINES.MC] = '#mc-config',
    _a[PRODUCT_LINES.ENGINE] = '#engine-config',
    _a[PRODUCT_LINES.MARINE] = '#marine-config',
    _a[PRODUCT_LINES.PSP] = '#psp-config',
    _a[PRODUCT_LINES.HC] = '#honda-config-app',
    _a[PRODUCT_LINES.HF] = '#honda-config-app',
    _a);
/**
 * Map of product line to a component that, when present on a page,
 * signifies that the page is a "model page", and contains data that
 * should be added to a GTM dataLayer payload
 */
export var MODEL_PAGE_COMPONENTS = (_b = {},
    _b[PRODUCT_LINES.HONDA] = 'ModelPageNav',
    _b[PRODUCT_LINES.ACURA] = 'ModelPageNav',
    _b[PRODUCT_LINES.PE] = 'ModelPageNav',
    _b[PRODUCT_LINES.MC] = 'ModelPageNav',
    _b[PRODUCT_LINES.ENGINE] = 'EngineDetailsCard',
    _b[PRODUCT_LINES.MARINE] = 'MarineProductDetailsCard',
    _b[PRODUCT_LINES.PSP] = 'ModelPageNav',
    _b);
